/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Model from '@ember-data/model';
import { attr, hasMany } from '@ember-data/model';
import type Setting from './setting';
import { inject as service } from '@ember/service';

export default class Banner extends Model {
  @service declare appService: $TSFixMe;

  @attr('string') declare appId: string;
  @attr('string') declare helpCenterSiteId: string;
  @attr('boolean') declare showBanner: boolean;

  @hasMany('consent-banners/setting', { async: false })
  declare settings: Setting[];

  rollbackAttributes() {
    super.rollbackAttributes();
    this.settings.forEach((setting) => {
      setting.rollbackAttributes();
    });
  }
}
